import { SquareColor, SummaryCardRow } from '../learn_summary_screen.tsx';
import {
  intervalBestStreak,
  IntervalPatternRecord,
  intervalSessionScore,
  intervalSummarySquares,
  trickiestMove,
} from './interval_session.ts';

// What an Interval Training session adds to the shared Learn summary (issue #3721), from the
// "Interval Training: session summary" artboard: the score, best streak and squares read from the
// session's pattern records, the line under the squares saying what green, yellow and red mean
// for a pattern, and the "Trickiest today" row naming the move the singer missed most. A session
// with every note on pitch has nothing to name, so it has no such row. The page spreads the result
// into <LearnSummaryScreen> with the props every exercise passes.

export const intervalSquaresCaption = 'Green: every note on pitch. Yellow: a note was close. Red: a note was missed.';
export const trickiestTodayLabel = 'Trickiest today';

export interface IntervalSummaryProps {
  score: number;
  bestStreak: number;
  squares: SquareColor[];
  squaresCaption: string;
  extraRows: SummaryCardRow[];
}

export function intervalSummaryProps(records: IntervalPatternRecord[]): IntervalSummaryProps {
  const trickiest = trickiestMove(records);
  return {
    score: intervalSessionScore(records),
    bestStreak: intervalBestStreak(records),
    squares: intervalSummarySquares(records),
    squaresCaption: intervalSquaresCaption,
    extraRows: trickiest === undefined ? [] : [{ label: trickiestTodayLabel, value: trickiest }],
  };
}
